export const ADD_REQUEST = 'ADD_ASSESSMENT_TEST/ADD_REQUEST'
export const ADD_SUCCESS = 'ADD_ASSESSMENT_TEST/ADD_SUCCESS'
export const ADD_ERROR = 'ADD_ASSESSMENT_TEST/ADD_ERROR'

export const GET_REQUEST = 'ADD_ASSESSMENT_TEST/GET_REQUEST'
export const GET_SUCCESS = 'ADD_ASSESSMENT_TEST/GET_SUCCESS'
export const GET_ERROR = 'ADD_ASSESSMENT_TEST/GET_ERROR'

export const ADD_CLEAR = 'ADD_ASSESSMENT_TEST/ADD_CLEAR'
